import { Children } from 'react';
import filter from './react-children-utilities/filter';
import groupBy from './react-children-utilities/group-by';
import map from './react-children-utilities/map';

export { filter, groupBy, map };

export default {
  ...Children,

  filter,
  groupBy,
  map,
};
